import landSpeckData from "./LandSpeck";
import starterGuideData from "./StarterGuide";
import energyGuide from "./Energy";
import petsGuide from "./petsGuide";
import questsData from "./quests";
import skillsGuide from "./skillsGuide";
import liveOpsGuide from "./liveOpsGuide";
import otherData from "./OtherGuides";
import MiscellaneousGuides from "./MiscData";
import ecosystemData from "./Ecosystem";
import currencyGuide from "./CurrencyData";
import aivGuideData from "../../../components/liveOpsComponents/aivGuide";
import neonZoneData from "../../../components/liveOpsComponents/neonZoneGuide";
import AnimalCareGuide from "./AnimalCareGuide";

const allGuides = [
    landSpeckData,
    starterGuideData,
    energyGuide,
    petsGuide,
    questsData,
    skillsGuide,
    liveOpsGuide,
    otherData,
    MiscellaneousGuides,
    ecosystemData,
    currencyGuide,
    aivGuideData,
    neonZoneData,
    AnimalCareGuide
];

export default allGuides;